import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

import { Message } from 'primeng/primeng';

@Injectable()
export class CommunicationService {
    
    //Observable source (Message)
    private messageSource = new Subject<Message>();
    //Observable stream (Message)
    Message$ = this.messageSource.asObservable();

    //Observable source for ProfileData
    private profileSource = new Subject<boolean>();
    //Observable stream for profileData
    Profile$ = this.profileSource.asObservable();

    constructor() {

    }

    //Service Message commands
    alertMessage(message: Message) {
        this.messageSource.next(message);
    }
    profileReceived(data:boolean){
        this.profileSource.next(data);
    }

    
}
